<template>
  <div class="space-y-6">
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Select Service Types
      </h3>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
        Choose the services you want to include in this engagement. You can select multiple.
      </p>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <label
          v-for="option in serviceOptions"
          :key="option.value"
          class="relative flex cursor-pointer rounded-xl border p-4 transition-colors"
          :class="isSelected(option.value)
            ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20'
            : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'"
        >
          <input
            type="checkbox"
            :value="option.value"
            :checked="isSelected(option.value)"
            class="sr-only"
            @change="toggleService(option.value)"
          />
          <div class="flex items-start gap-3 w-full">
            <div
              class="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border transition-colors"
              :class="isSelected(option.value)
                ? 'border-primary-500 bg-primary-500'
                : 'border-gray-300 dark:border-gray-600'"
            >
              <svg
                v-if="isSelected(option.value)"
                class="h-3.5 w-3.5 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="3"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <div class="text-sm font-medium text-gray-900 dark:text-gray-100">
                {{ option.title }}
              </div>
              <div class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                {{ option.description }}
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

const serviceOptions = [
  { value: 'seo', title: 'SEO', description: 'Search engine optimization for organic rankings and traffic.' },
  { value: 'ppc_adwords', title: 'PPC - Google Ads', description: 'Pay-per-click advertising through Google Ads (Adwords).' },
  { value: 'ppc_lsa', title: 'PPC - Local Service Ads', description: 'Google Local Service Ads for local lead generation.' }
]

const selectedServices = ref([])

function isSelected(value) {
  return selectedServices.value.includes(value)
}

function toggleService(value) {
  const idx = selectedServices.value.indexOf(value)
  if (idx >= 0) {
    selectedServices.value.splice(idx, 1)
  } else {
    selectedServices.value.push(value)
  }
}

onMounted(() => {
  selectedServices.value = [...(props.onboarding.service_types || [])]
})

defineExpose({
  getData: () => ({ service_types: [...selectedServices.value] })
})
</script>
